import React from "react";


const PlusIcon = props => {

    return (
        <svg id="Group_629" data-name="Group 629" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
            <line id="Line_133" data-name="Line 133" y2="19" transform="translate(9.5)" fill="none" stroke="#707070" stroke-width="1.5" />
            <line id="Line_134" data-name="Line 134" y2="19" transform="translate(19 9.5) rotate(90)" fill="none" stroke="#707070" stroke-width="1.5" />
        </svg>

    );

}

export default PlusIcon;